import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  viewBox: "0 0 90 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M69.7 15h-3.1v7.7h-7.7v3.1h7.7v7.7h3.1v-7.7h7.7v-3.1h-7.7z" }, null, -1),
    _createElementVNode("path", { d: "M68.2 5c-10.7 0-19.3 8.6-19.3 19.2s8.7 19.2 19.3 19.2 19.3-8.6 19.3-19.2S78.8 5 68.2 5m0 35.4c-9 0-16.2-7.2-16.2-16.2S59.2 8.1 68.2 8.1s16.2 7.2 16.2 16.2-7.3 16.1-16.2 16.1" }, null, -1),
    _createElementVNode("path", { d: "M68.2 91.9H15.6V24.2h29.6v-3H12.5V95h58.8V46.6h-3.1z" }, null, -1)
  ]))]))
}
export default { render: render }